import { render, staticRenderFns } from "./EquipmentSpecificationsTable.vue?vue&type=template&id=771ab9a7"
import script from "./EquipmentSpecificationsTable.vue?vue&type=script&lang=js"
export * from "./EquipmentSpecificationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports